import { createSelector } from 'reselect';
import { IQualificationState } from './types';

const selectQualificationState = (state: { qualification: IQualificationState }) => state.qualification;

export const selectQualificationList = createSelector(
  selectQualificationState,
  (qualificationState) => qualificationState.list.results
);

export const selectQualificationListLoading = createSelector(
  selectQualificationState,
  (qualificationState) => qualificationState.loading
);

export const selectQualificationListError = createSelector(
  selectQualificationState,
  (qualificationState) => qualificationState.error
);

export const selectQualificationListCount = createSelector(
  selectQualificationState,
  (qualificationState) => qualificationState.list.count
);
